<div *ngIf="flatPills.length > 0" class="selected-filters">
    <ng-container *ngFor="let pill of flatPills">
        <span class="selected-filter" [ngClass]="pill.cssClass">
            <i class="material-icons">{{ pill.icon }}</i>
            <span class="filter-label">{{ pill.displayValue }}</span>
            <button (click)="onRemovePill(pill)" class="remove-filter">
                <i class="fa fa-times"></i>
            </button>
        </span>
    </ng-container>
</div>